var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.826 1.60574C10.6795 1.45824 10.441 1.45824 10.2955 1.60574L4.705 7.17024C4.5585 7.31874 4.3195 7.31874 4.174 7.17024L1.7245 4.67574C1.652 4.60174 1.557 4.56524 1.4615 4.56474C1.365 4.56424 1.267 4.60074 1.1935 4.67574L0.111 5.64874C0.039 5.72274 0 5.81524 0 5.91174C0 6.00874 0.039 6.11024 0.1115 6.18374L2.5815 8.77574C2.7275 8.92374 2.967 9.16374 3.1125 9.31074L4.1745 10.3812C4.3205 10.5277 4.559 10.5277 4.7055 10.3812L11.8885 3.21124C12.035 3.06424 12.035 2.82274 11.8885 2.67574L10.826 1.60574Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.daa5aa1e7fe51c0971a2ee1b3882811d.svg";
export { ForwardRef as ReactComponent };